<template>
  <div id="tac-admin-dropship-sync">
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-admin-dropship-sync -->
</template>

<script>
import AuthMixin from '@/plugin/mixin/auth'

export default {
  mixins: [
    AuthMixin
  ]
}
</script>
